<div class="loading">
  <span class="loader"></span>
</div>
